import catalog from './toolTitles.json';

/**
 * How each tool reads to a person — "Editing file" with the path beside it, never `vfs_patch`. The catalog is
 * exported from the vfs-service MCP server (`node scripts/export-tool-titles.js`, tool `title` + `mia/summary` +
 * `mia/kind`) into toolTitles.json: copy it, do not edit it here. Tools of other servers fall back to their
 * humanized name; the few this app's backend still serves itself are listed below.
 *
 * `kind` drives the group's aggregate summary text and which calls get a drill-down in ToolCallDetailSheet
 * ('write' -> diff view, 'command' -> stdout/stderr, everything else -> plain read-only detail).
 */
const LOCAL_TITLES = {
    execute_python_code: { title: 'Running Python', kind: 'command' },
    vfs_promote_project_to_catalog: { title: 'Promoting to Catalog', kind: 'other', summary: 'name' },
    vfs_promote_project_to_console: { title: 'Promoting to Console', kind: 'other' },
};

const TITLES = { ...catalog, ...LOCAL_TITLES };

export function humanizeToolName(name) {
    const words = String(name || '').replace(/^vfs_/, '').replace(/[_\-.]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!words) { return String(name || ''); }
    return words.charAt(0).toUpperCase() + words.slice(1);
}

function summaryOf(entry, args) {
    if (!entry?.summary || !args) { return null; }
    for (const key of [].concat(entry.summary)) {
        const value = args[key];
        const text = Array.isArray(value) ? value.filter((v) => typeof v === 'string').join(', ') : value;
        if (typeof text === 'string' && text.trim()) { return text.trim(); }
    }
    return null;
}

/** { verb, kind, summary } for a tool call: the verb is always a sentence, the summary the argument worth showing. */
export function describeTool(name, args) {
    const entry = Object.prototype.hasOwnProperty.call(TITLES, name) ? TITLES[name] : null;
    return {
        verb: entry?.title || humanizeToolName(name),
        kind: entry?.kind || 'other',
        summary: summaryOf(entry, args),
    };
}
